import { delay, http, HttpResponse } from 'msw';
import { APPROVAL_WORKFLOW } from '../data/configuration/approval-workflow';
import { errorCodes } from '~/constants';

const getRelatedTransactionsError = () => {
  return HttpResponse.json(
    {
      CaseId: 'MockCaseId',
      Code: errorCodes.ERR_ACTION_FORBIDDEN,
      Message: 'There are still transactions related to this workflow',
      From: 'BoPrivateAPi'
    },
    { status: 400 }
  );
};

export const approvalWorkflowHandlers = [
  http.get('**/approvalWorkflows*', () => {
    return HttpResponse.json(APPROVAL_WORKFLOW.getApprovalWorkflows);
  }),

  http.put('**/approvalWorkflows/:operation', async ({ params, request }) => {
    const { operation } = params;
    const body = (await request.clone().json()) as {
      WorkflowOperation: string;
      NumberOfValidators: number;
    };
    if (operation === 'moneyIn') {
      return getRelatedTransactionsError();
    }

    const workflow = APPROVAL_WORKFLOW.getApprovalWorkflows.find(
      (w) => w.WorkflowOperation === operation
    );

    if (workflow) {
      workflow.NumberOfValidators = body.NumberOfValidators;
    }
    await delay();
    return HttpResponse.json({});
  }),

  http.post('**/approvalWorkflows', async ({ request }) => {
    const body = (await request.clone().json()) as {
      WorkflowOperation: string;
      NumberOfValidators: number;
    };
    APPROVAL_WORKFLOW.getApprovalWorkflows.push(body);
    await delay();
    return HttpResponse.json(undefined, { status: 201 });
  }),

  http.delete('**/approvalWorkflows/:operation', async ({ params, request }) => {
    const { operation } = params;
    const body = (await request.clone().json()) as { Password?: string } | null;
    if (!body?.Password || body.Password !== 'adminmb') {
      return HttpResponse.json(
        {
          Code: errorCodes.ERR_WRONG_PASSWORD,
          Message: 'Invalid password provided',
          From: 'BoPrivateAPi'
        },
        { status: 400 }
      );
    }
    if (operation === 'moneyIn') {
      return getRelatedTransactionsError();
    }
    const index = APPROVAL_WORKFLOW.getApprovalWorkflows.findIndex(
      (w) => w.WorkflowOperation === operation
    );

    if (index !== -1) {
      APPROVAL_WORKFLOW.getApprovalWorkflows.splice(index, 1);
    }
    await delay();
    return HttpResponse.json(undefined, { status: 204 });
  })
];
